<template>
<div class="subject-box">
  <div class="subject-box-title">
    <div class="title-left">
      <p class="china-title">{{currentQuestionList1.tips_cnname}}</p>
      <p class="en-title">{{currentQuestionList1.tips_enname}}</p>
    </div>
    <div class="title-right" v-if="currentQuestionList1.has_audio==1">
      <div class="audio-add" @click="playAudio">
        <div class="audio-box" style="position:relative;z-index:10;"></div>
        <audio class="audio" id="audioPlay" ref="audio" controls :src="currentQuestionList1.question_audio" autoplay ></audio>
      </div>
    </div>
  </div>
  <div class="subject-content-box flex-align">
    <div class="subject-content sort-box">
      <!-- 文字排序 -->
      <div class="wordSort myWordDrag" v-if="currentQuestionList1.category_id==13">
        <div class="word-box" style="margin-bottom:20px;text-align:center;" v-html="currentQuestionList1.question_title"></div>
        <div class="isHasImg" v-if="currentQuestionList1.has_img==1">
          <img :src="currentQuestionList1.question_titleimg" alt />
        </div>
        <div class="words-sorts">
          <div class="img-drag-source" style="margin-bottom:20px">
            <!-- <vuedraggable :list="listword2" :options="{group:{name: falgs,pull:'clone'},filter: '.undraggable', sort: false}"  @end="word2End" id="dragArea" class="dragArea">
              <div v-for="(element,index) of listword2" :key="index" :class="{undraggable : element.flag}" class="list-complete-item cursor">
                <div class="list-complete-item-handle">
                  <div class="my-word">{{element.answers_option}}</div>
                </div>
              </div>
            </vuedraggable> -->
            <vuedraggable 
             class="dragArea list-group"
              :list="listword2" 
              :clone="cloneWord"
              :group="{ name: 'peopleWorld', pull: pullFunctionWord }"
              @start="startWordTop"
              @end="endWordTop"
            >
              <div v-for="(element,index) of listword2" :key="index" :class="{undraggable : element.flag}" class="list-complete-item list-group-item cursor">
                <div class="list-complete-item-handle">
                  <div class="my-word">{{element.answers_option}}</div>
                </div>
              </div>
            </vuedraggable>
            <div class="Answer-area">{{$t('Evaluation.questionArea')}}</div>
          </div>
          <div class="img-drag-target">
            <!-- <vuedraggable :list="listword1" :options="{group:{name:'article',}, disabled: disabled}" id="dragArea11" @start="word1Start" @end="word1End" class="dragArea">
              <div v-for="(element,index) of listword1" :key="index" class="list-complete-item cursor">
                <div class="list-complete-item-handle">
                  <div class="my-word">{{element.answers_option}}</div>
                </div>
                <div>
                </div>
              </div>
            </vuedraggable> -->
            <vuedraggable 
             class="dragArea"
             :list="listword1" 
             group="peopleWorld" 
             @end="endWordBottom"
            >
              <div v-for="(element,index) of listword1" :key="index" class="list-complete-item cursor">
                <div class="list-complete-item-handle">
                  <div class="my-word">{{element.answers_option}}</div>
                </div>
                <div>
                </div>
              </div>
            </vuedraggable>
            <div class="Answer-area">{{$t('Evaluation.AnsweringArea')}}</div>
          </div>
        </div>
        <!-- <div class="words-list">
          <span v-for="(item,index) of currentQuestionList1.option" :key="index">{{item.answers_option}}</span>
        </div>
        <div class="sort-input-box">
          <input type="text" v-model="picked" class="ipt" />
        </div> -->
      </div>
      <!-- 句子排序 -->
      <div class="sentenceSort" v-if="currentQuestionList1.category_id==21">
        <h3 v-html="currentQuestionList1.question_title" style="margin-bottom:20px;font-size:14px;"></h3>
        <template v-if="list.length > 0">
          <vuedraggable class="wrapper" v-model="list" :options="{animation:500,dragClass:'dragSort'}" @change="dragChange">
            <!-- <transition-group > -->
              <div class="item cursor" v-for="(item,index) of list" :key="index">
                <span class="option">{{item.answers_optionname}}</span>
                <p class="sentence">{{item.answers_option}}</p>
              </div>
            <!-- </transition-group> -->
          </vuedraggable>
        </template>
      </div>
      <!-- 图片排序 -->
      <div class="imgSort" v-if="currentQuestionList1.category_id==14">
        <h3 v-html="currentQuestionList1.question_title"></h3>
        <div class="img-drag">
          <!-- :options="{group:{name: falgs,pull:'clone'},filter: '.undraggable', sort: false}" -->
          <div class="img-drag-source" style="margin-bottom:20px">
            <!-- <vuedraggable :list="list2" :options="{group:{name: falgs,pull:'clone'},filter: '.undraggable', sort: false}" @start="start" @end="end" id="dragArea" class="dragArea">
              <div v-for="(element,index) of list2" :key="index" :class="{undraggable : element.flag}" class="list-complete-item ">
                <div class="list-complete-item-handle">
                  <div class="imgs-box">
                    <img :src="element.answers_optionimg" alt />
                    <span class="num">{{element.answers_optionname}}</span>
                  </div>
                </div>
              </div>
            </vuedraggable> -->
            <vuedraggable 
              class="dragArea list-group"
              :list="list2"
              :clone="clone"
              :group="{ name: 'people', pull: pullFunction }"
              @start="startImgTop"
              @end="endImgTop"
            >
              <div v-for="(element,index) of list2" :key="index" :class="{undraggable : element.flag}" class="list-complete-item list-group-item">
                <div class="list-complete-item-handle">
                  <div class="imgs-box">
                    <img :src="element.answers_optionimg" alt />
                    <span class="num">{{element.answers_optionname}}</span>
                  </div>
                </div>
              </div>
            </vuedraggable>
            <div class="Answer-area">{{$t('Evaluation.questionArea')}}</div>
          </div>
          <div class="img-drag-target">
            <vuedraggable 
              class="dragArea"
              :list="list1" 
              group="people" 
              @end="endImgBottom"
            >
              <div v-for="(element,index) of list1" :key="index" class="list-complete-item list-group-item">
                <div class="list-complete-item-handle">
                  <div class="imgs-box">
                    <img :src="element.answers_optionimg" alt />
                  </div>
                </div>
                <div>
                  <!-- <i class="el-icon-delete" @click="handleDel(index, element.id)"></i> -->
                </div>
              </div>
            </vuedraggable>
            <div class="Answer-area">{{$t('Evaluation.AnsweringArea')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import vuedraggable from "vuedraggable";
export default {
  name: "Sort",
  props: {
    currentQuestionList: {
      type: Object
    },
    //当前点击到 第几题
    currentId: {
      type: Number
    },
    //当前题目答案格式
    anwsersAll: {
      type: Object
    },
    //所有题目答案格式
    anwsersListAll:{
      type: Array
    },
    //  propIndex:{
    //   type: Number
    // },
    propChild: {
      type: Object
    },
  },
  components: {
    vuedraggable
  },
  data() {
    return {
      currentQuestionList1: {},
      category: 3,
      list: [],//句子排序
      picked: "",
      falgs: "article",
      disabled: false,
      listword1: [],//文字排序 -下
      listword2: [],//文字排序 -上
      list1: [],//图片排序 -下
      list2: [],//图片排序 -上
      controlOnStart: true,
      anwsersListAllReplace:[],//图片排序的替代
      sentenceListAllReplace:[],//句子排序的替代
      wordListAllReplace:[],//文字排序的替代
    };
  },
  watch: {
    getData(n, o) {
      console.log(n, o, 'n -- o');
      // console.log(this.currentId)
      let index = this.currentId;
      this.currentQuestionList1 = n;
      // console.log(index,'当前index')
      // console.log(this.anwsersListAll[index].answers.length)
      // console.log(this.anwsersListAll,'全部')
      // console.log(this.anwsersAll,'当前')

      //-----句子排序------开始
      if(this.sentenceListAllReplace[index].answers.length>0){//当前题目有答案
        //句子排序
        this.list = [...this.sentenceListAllReplace[index].answers];
      }else{
        this.list = n.option; //句子排序
      }
      //-----句子排序------结束

      //-----图片排序-----开始
      if(this.anwsersListAllReplace[index].answers.length>0){ // 当前题目有答案
        //图片排序 - 下面
        let _this = this;
        this.list1 = [...this.anwsersListAllReplace[index].answers];
        // this.list2 = n.option; //图片排序 - 上面
        let newArr = []
        let newArr1 = []
        n.option.forEach(item1=>{
          _this.anwsersListAllReplace[index].answers.forEach(item2=>{
            if( item1.answers_optionname == item2.answers_optionname){
              newArr.push(item1.answers_optionname)
            }
          })
        })
        
        newArr1 = n.option.filter(e => newArr.indexOf(e.answers_optionname) == -1);
        this.list2 = newArr1; //图片排序 - 上面
        console.log(newArr,'我是相同的数据')
        console.log(newArr1,'我是上面的数据')
        console.log(newArr,'我是新数据')
      }else{
        this.list1 = [];//图片排序 - 下面
        this.list2 = n.option; //图片排序 - 上面
      }
      //--------- 文字排序 ------ 开始
      if(this.wordListAllReplace[index].answers.length>0){ // 当前题目有答案
        //图片排序 - 下面
        let _this = this;
        this.listword1 = [...this.anwsersListAllReplace[index].answers];
        // this.list2 = n.option; //图片排序 - 上面
        let newArr = []
        let newArr1 = []
        n.option.forEach(item1=>{
          _this.anwsersListAllReplace[index].answers.forEach(item2=>{
            if( item1.answers_optionname == item2.answers_optionname){
              newArr.push(item1.answers_optionname)
            }
          })
        })
        
        newArr1 = n.option.filter(e => newArr.indexOf(e.answers_optionname) == -1);
        this.listword2 = newArr1; //图片排序 - 上面
        console.log(newArr,'我是相同的数据')
        console.log(newArr1,'我是上面的数据')
        console.log(newArr,'我是新数据')
      }else{
        this.listword1 = [];//文字排序 - 下面
        this.listword2 = n.option; //文字排序
      }
    },
    //--------- 文字排序 ------ 结束
    getData1(n, o) {
      console.log(22222);
    },
    quetionClick(n, o) {}
  },
  computed: {
    getData() {
      return this.currentQuestionList;
    },
    getData1() {
      return this.propChild;
    },
    quetionClick() {
      return this.currentId;
    }
  },
  created() {
    this.anwsersListAllReplace =[];
    this.anwsersListAllReplace = this.anwsersListAll;
    console.log(this.anwsersListAll,'所有题目')

    this.sentenceListAllReplace =[];
    this.sentenceListAllReplace = this.anwsersListAll;

    this.wordListAllReplace = [];
    this.wordListAllReplace = this.anwsersListAll;

    this.currentQuestionList1 = this.propChild?this.propChild:this.currentQuestionList;
    console.log('----------------------')
  },
  // props: ['title'],
  methods: {
    playAudio() {
      console.log(333);
      let audio = this.$refs.audio;
      audio.play();
    },
    //句子排序
    dragChange(event) {
      console.log(event);
      console.log(this.list);
      this.anwsersAll.answers = [...this.list];
      this.sentenceListAllReplace =[];
      this.sentenceListAllReplace = Array.from(this.anwsersListAll);
      this.$emit('dragWordClickChange')
    },
    //---------图片排序 开始----------
    clone(param) {
      console.log(param,'克隆-------->>>>>')
      // console.log(name,'克隆-------->>>>>',idGlobal)
      return param;
    },
    pullFunction() {
      let param = this.list2[0]
      return this.controlOnStart ? "clone(param)" : true;
    },
    startImgTop({ originalEvent }) {
      console.log(originalEvent,'开始')
    },
    endImgTop({ originalEvent }){
      console.log(originalEvent,'结束')
      console.log(this.list2,this.list2.length,'我是上面')
      console.log(this.list1,this.list1.length,'我是下面')
      this.controlOnStart = originalEvent.ctrlKey;

      this.anwsersAll.answers = [...this.list1];
      
      this.anwsersListAllReplace = [];
      this.anwsersListAllReplace = this.anwsersListAll;
      console.log(this.anwsersAll.answers,'当前题目答案')
      console.log(this.anwsersListAllReplace,'所有题目')
    },
    endImgBottom(){
      console.log('从下往上')
      console.log(this.list2,this.list2.length)
      console.log(this.list1,this.list1.length)
    },
     //---------图片排序 结束----------
    //---------文字排序 开始----------
    cloneWord(param) {
      console.log(param,'克隆-------->>>>>')
      // console.log(name,'克隆-------->>>>>',idGlobal)
      return param;
    },
    pullFunctionWord() {
      let param = this.listword2[0]
      return this.controlOnStart ? "cloneWord(param)" : true;
    },
    startWordTop({ originalEvent }) {
      console.log(originalEvent,'开始')
    },
    endWordTop({ originalEvent }){
      console.log(originalEvent,'结束')
      console.log(this.listword2,this.listword2.length,'我是上面')
      console.log(this.listword1,this.listword1.length,'我是下面')
      this.controlOnStart = originalEvent.ctrlKey;

      this.anwsersAll.answers = [...this.listword1];
      
      this.anwsersListAllReplace = [];
      this.anwsersListAllReplace = this.anwsersListAll;
      console.log(this.anwsersAll.answers,'当前题目答案')
      console.log(this.anwsersListAllReplace,'所有题目')
    },
    endWordBottom(){
      console.log('从下往上')
      console.log(this.list2,this.list2.length)
      console.log(this.list1,this.list1.length)
      console.log(this.listword1, 'listword1 listword1')

      this.anwsersAll.answers = [...this.listword1];
      this.anwsersListAllReplace = [];
      this.anwsersListAllReplace = this.anwsersListAll;
    },
     //---------文字排序 结束----------
    handleDel(index, id) {
      this.list1.splice(index, 1);
      let q = this.list2.find((value, index, arr) => {
        return value.id === id;
      });
      this.$set(q, "flag", false);
    }
  }

};
</script>

<style lang="less">
// .list-complete-item {
//   cursor: pointer;
//   position: relative;
//   font-size: 14px;
//   padding: 5px 12px;
//   display: inline-block;
//   margin-right: 20px;
//   width: 50px;
//   height: 50px;
//   border: 1px solid #bfcbd9;
//   transition: all 1s;
// }

// .list-complete-item.sortable-chosen {
//   background: #4ab7bd;
// }

// .list-complete-item.sortable-ghost {
//   background: #30b08f;
// }
// .undraggable {
//   background-color: red;
// }

// .list-complete-enter,
// .list-complete-leave-active {
//   opacity: 0;
// }
//文字排序
.myWordDrag{
  .words-sorts{
    .dragArea{
      display: flex;
      min-block-size: 40px;
      .list-complete-item{
        margin-right: 20px;
        .my-word{
          display: inline-block;
          background:rgba(255,255,255,1);
          box-shadow:0px 2px 5px 0px rgba(0,0,0,0.05);
          padding: 10px;
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
    .Answer-area{
      border-bottom: 1px solid #dddd;
      padding-bottom: 15px;
      text-align: center;
      margin-top: 20px;
    }
  }
}
.imgSort {
  h3 {
    font-size: 15px;
    margin-bottom: 30px;
    color: #333333;
  }

  .img-drag {
    .dragArea {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      min-height:140px;
      .list-complete-item {
        // width: 180px;
        // height: 180px;
        border-radius: 8px;
        border: 1px solid rgba(221, 221, 221, 1);
        transition: all 1s;
        cursor: pointer;
        margin-right: 25px;
        margin-bottom: 25px;

        &:last-child {
          margin-right: 0;
        }

        .imgs-box {
          width: 140px;
          height: 140px;
          position: relative;

          img {
            width: 100%;
            max-height: 100%;
            border-radius: 8px;
          }

          .num {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 30px;
            color: #ffffff;
            font-weight: bold;
          }
        }
      }
    }
  }

  .Answer-area {
    border-bottom: 1px solid #dddd;
    padding-bottom: 15px;
    text-align: center;
  }

  //   .list-complete-item.sortable-chosen {
  //   background: #4ab7bd;
  //   border:3px solid #4ab7bd;
  // }

  // .list-complete-item.sortable-ghost {
  //   background: #30b08f;
  //    border:3px solid blue;
  // }
  // .undraggable {
  //   background-color: red;
  //   border:3px solid red;
  // }
}
</style>
